module.exports = __webpack_public_path__ + "static/img/3.d1cf3b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/4/3.png
// module id = 242
// module chunks = 0